import {Body, Desc, Images, Logo, PageIcon, Title} from "./style";
import {LogoIcon} from "../../components/Header";
import {useApp} from "../../contexts/app";
import {ContainerImage} from "../../components/Container";

export default function NotFound(props:any) {
    const {campaign, customer, T} = useApp();

    return (
        <ContainerImage
            style={{overflowY: 'auto', minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Logo>
                <LogoIcon/>
            </Logo>
            <Body>
                <Images>
                    <PageIcon/>
                </Images>
                <Title>404 Error</Title>
                <Desc>{T('Page not found')}</Desc>
                {/*<Next onClick={() => {*/}
                {/*    window.location.href = window.location.href.replace('/404', "")*/}
                {/*}}>{T("Try again")}</Next>*/}
            </Body>
        </ContainerImage>
    );
}